export default __webpack_public_path__ + "static/media/loading.630b3e19.svg";